import React, { FC } from 'react';
import {
  AtlassianIcon,
  BitbucketIcon,
  CompassIcon,
  ConfluenceIcon,
  JiraWorkManagementIcon,
  JiraIcon,
  JiraServiceManagementIcon,
  JiraSoftwareIcon,
  OpsgenieIcon,
  StatuspageIcon,
  TrelloIcon,
  LogoProps,
  LoomIcon,
  GuardIcon,
  JiraAlignIcon,
} from '@atlaskit/logo';
import {
  AtlasIcon,
  BambooIcon,
  CloverIcon,
  CrowdIcon,
  CrucibleIcon,
  FisheyeIcon,
  GitIcon,
  HalpIcon,
  SourcetreeIcon,
  MarketingIcon,
  AgileInsidersNewsletterIcon,
} from './icons';

interface OwnProps {
  title: string;
}

const ItemIcon: FC<OwnProps> = ({ title }) => {
  const defaultProps: LogoProps = {
    size: 'xlarge',
    appearance: 'brand',
  };
  switch (title) {
    case 'jiraMacApp':
    case 'automationForJiraProductRecommendationsCloud':
    case 'automationForJiraProductUpgradesCloud':
    case 'automationForJiraTipsAndTricksCloud':
    case 'automationForJiraProductRecommendationsServer':
    case 'iconsForJiraProductRecommendationsServer':
    case 'automationForJiraProductUpgradesServer':
    case 'iconsForJiraProductUpgradesServer':
    case 'automationForJiraTipsAndTricksServer':
    case 'iconsForJiraTipsAndTricksServer':
    case 'productRecommendationsAdvancedRoadmapsForJiraCloud':
    case 'productRecommendationsJiraSoftwareCloud':
    case 'productUpgradesAdvancedRoadmapsForJiraCloud':
    case 'productUpgradesJiraSoftwareCloud':
    case 'jiraSoftwareTechAlerts':
    case 'jiraCloudCSComms':
      return <JiraIcon {...defaultProps} testId='jira-icon' />;
    case 'jiraServerNewsletter':
    case 'jiraSoftwareProductRecommendationsCloud':
    case 'jiraSoftwareProductRecommendationsServer':
    case 'jiraSoftwareProductUpgradesCloud':
    case 'jiraSoftwareProductUpgradesServer':
    case 'jiraSoftwareTipsAndTricksCloud':
    case 'jiraSoftwareTipsAndTricksServer':
    case 'productUpgradesJiraSoftwareDataCenter':
    case 'productUpgradesJiraSoftwareServer':
    case 'productRecommendationsJiraSoftwareDataCenter':
    case 'productRecommendationsJiraSoftwareServer':
      return <JiraSoftwareIcon {...defaultProps} testId='jira-software-icon' />;
    case 'jiraServiceDeskTechAlerts':
    case 'jiraServiceDeskProductRecommendationsCloud':
    case 'jiraServiceDeskProductRecommendationsServer':
    case 'jiraServiceDeskProductUpgradesCloud':
    case 'jiraServiceDeskProductUpgradesServer':
    case 'jiraServiceDeskTipsAndTricksCloud':
    case 'jiraServiceDeskTipsAndTricksServer':
    case 'jsmCloudCSComms':
    case 'productRecommendationsJiraServiceDeskCloud':
    case 'productRecommendationsJiraServiceDeskDataCenter':
    case 'productRecommendationsJiraServiceDeskServer':
    case 'productUpgradesJiraServiceDeskCloud':
    case 'productUpgradesJiraServiceDeskDataCenter':
    case 'productUpgradesJiraServiceDeskServer':
      return <JiraServiceManagementIcon {...defaultProps} testId='jira-service-management-icon' />;
    case 'jiraOps':
    case 'jiraCoreTechAlerts':
    case 'jiraCoreProductRecommendationsCloud':
    case 'jiraCoreProductRecommendationsServer':
    case 'jiraCoreProductUpgradesCloud':
    case 'jiraCoreTipsAndTricksCloud':
    case 'productRecommendationsJiraCoreCloud':
    case 'productRecommendationsJiraCoreDataCenter':
    case 'productRecommendationsJiraCoreServer':
    case 'productUpgradesJiraCoreCloud':
    case 'productUpgradesJiraCoreDataCenter':
    case 'productUpgradesJiraCoreServer':
      return <JiraWorkManagementIcon {...defaultProps} testId='jira-work-management-icon' />;
    case 'confluenceCloudCSComms':
    case 'confluenceInsidersNewsletter':
    case 'confluenceTechAlerts':
    case 'confluenceProductRecommendationsCloud':
    case 'confluenceProductRecommendationsServer':
    case 'confluenceProductUpgradesCloud':
    case 'confluenceProductUpgradesServer':
    case 'confluenceTipsAndTricksCloud':
    case 'confluenceTipsAndTricksServer':
    case 'analyticsForConfluenceAppProductRecommendationsServer':
    case 'productRecommendationsConfluenceCloud':
    case 'productRecommendationsConfluenceDataCenter':
    case 'productRecommendationsConfluenceServer':
    case 'productUpgradesConfluenceCloud':
    case 'productUpgradesConfluenceDataCenter':
    case 'productUpgradesConfluenceServer':
      return <ConfluenceIcon {...defaultProps} testId='confluence-icon' />;
    case 'bitbucketTechAlerts':
    case 'bitbucketProductRecommendationsCloud':
    case 'bitbucketProductRecommendationsServer':
    case 'bitbucketProductUpgradesCloud':
    case 'bitbucketProductUpgradesServer':
    case 'bitbucketTipsAndTricksCloud':
    case 'bitbucketTipsAndTricksServer':
    case 'productUpgradesBitbucketCloud':
    case 'productUpgradesBitbucketDataCenter':
    case 'productUpgradesBitbucketServer':
    case 'productRecommendationsBitbucketCloud':
    case 'productRecommendationsBitbucketDataCenter':
    case 'productRecommendationsBitbucketServer':
      return <BitbucketIcon {...defaultProps} testId='bitbucket-icon' />;
    case 'trelloCSComms':
    case 'trelloProductRecommendationsCloud':
    case 'trelloPowerUpsProductRecommendationsCloud':
    case 'trelloProductUpgradesCloud':
    case 'trelloPowerUpsProductUpgradesCloud':
    case 'trelloTipsAndTricksCloud':
    case 'trelloPowerUpsTipsAndTricksCloud':
    case 'productUpgradesTrello':
    case 'productRecommendationsTrello':
      return <TrelloIcon {...defaultProps} testId='trello-icon' />;
    case 'statuspageProductRecommendationsCloud':
    case 'statuspageProductUpgradesCloud':
    case 'statuspageTipsAndTricksCloud':
    case 'productRecommendationsStatuspageCloud':
    case 'productUpgradesStatuspageCloud':
      return <StatuspageIcon {...defaultProps} testId='statuspage-icon' />;
    case 'opsgenieProductRecommendationsCloud':
    case 'opsgenieProductUpgradesCloud':
    case 'opsgenieTipsAndTricksCloud':
    case 'opsgenieOnboarding':
    case 'productRecommendationsOpsgenieCloud':
    case 'productUpgradesOpsgenieCloud':
      return <OpsgenieIcon {...defaultProps} testId='opsgenie-icon' />;
    case 'bambooTechAlerts':
    case 'bambooProductRecommendationsServer':
    case 'bambooProductUpgradesServer':
    case 'bambooTipsAndTricksServer':
    case 'productRecommendationsBambooServer':
    case 'productUpgradesBambooServer':
      return <BambooIcon data-testid='bamboo-icon' />;
    case 'cloverTechAlerts':
      return <CloverIcon data-testid='clover-icon' />;
    case 'crowdTechAlerts':
    case 'crowdProductRecommendationsServer':
      return <CrowdIcon data-testid='crowd-icon' />;
    case 'crucibleTechAlerts':
    case 'crucibleProductRecommendationsServer':
    case 'crucibleProductUpgradesServer':
    case 'crucibleTipsAndTricksServer':
      return <CrucibleIcon data-testid='crucible-icon' />;
    case 'fisheyeTechAlerts':
    case 'fisheyeProductRecommendationsServer':
      return <FisheyeIcon data-testid='fisheye-icon' />;
    case 'sourcetreeProductRecommendationsServer':
    case 'sourcetreeProductUpgradesServer':
    case 'sourcetreeTipsAndTricksServer':
    case 'productRecommendationsSourcetree':
    case 'productUpgradesSourcetree':
      return <SourcetreeIcon data-testid='sourcetree-icon' />;
    case 'productRecommendationsHalp':
    case 'productUpgradesHalp':
      return <HalpIcon data-testid='halp-icon' />;
    case 'jiraAlignProductRecommendationsCloud':
    case 'jiraAlignProductUpgradesCloud':
    case 'jiraAlignTipsAndTricksCloud':
    case 'productRecommendationsJiraAlignCloud':
    case 'productRecommendationsJiraAlignDataCenter':
    case 'productRecommendationsJiraAlignServer':
    case 'productUpgradesJiraAlignCloud':
    case 'productUpgradesJiraAlignDataCenter':
    case 'productUpgradesJiraAlignServer':
      return <JiraAlignIcon {...defaultProps} testId='jira-align-icon' />;
    case 'compassDigest':
    case 'compassNewsletter':
    case 'productRecommendationsCompassCloud':
    case 'productUpgradesCompassCloud':
      return <CompassIcon {...defaultProps} testId='compass-icon' />;
    case 'gitInsidersNewsletter':
      return <GitIcon data-testid='git-icon' />;
    case 'generalMarketingOptIn':
      return <MarketingIcon data-testid='marketing-icon' />;
    case 'productRecommendationsTeamCentralCloud':
      return <AtlasIcon data-testid='atlas-icon' />;
    case 'jiraInsidersNewsletter':
      return <AgileInsidersNewsletterIcon data-testid='agile-insiders-newsletter-icon' />;
    case 'beaconNewsletter':
    case 'productRecommendationsAtlassianAccess':
    case 'productUpgradesAtlassianAccess':
      return <GuardIcon {...defaultProps} testId='atlassian-guard-icon' />;
    case 'loomProductEngagements':
    case 'loomReplayNewsletter':
    case 'productRecommendationsLoomCloud':
    case 'productUpgradesLoomCloud':
      return <LoomIcon {...defaultProps} testId='loom-icon' />;
    default:
      return <AtlassianIcon {...defaultProps} testId='atlassian-icon' />;
  }
};

export default ItemIcon;
